import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const MChip = ({ text, color, borderColor, margin, className }) => (
  <ChipCon
    $color={color}
    $borderColor={borderColor}
    $margin={margin}
    className={`${className} mr-chip`}
  >
    {text}
  </ChipCon>
);
const ChipCon = styled.span`
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.15px;
  color: ${props => props.$color};
  margin: ${props => (props.$margin ? props.$margin : '2px 4px')};
  padding: 2px 8px;
  border-radius: 10px;
  display: inline-block;
  border: 1px solid ${props => props.$borderColor};
`;

MChip.propTypes = {
  text: PropTypes.string,
  color: PropTypes.string,
  borderColor: PropTypes.string,
  margin: PropTypes.string,
  className: PropTypes.string,
};
